import { isHasMessage } from './hasMessage'
import { isCustomError } from './isCustomError'

export const getError = (err: unknown) => {
  return isCustomError(err)
    ? err.response.data.message
    : isHasMessage(err)
    ? err.message
    : 'Error message not found'
}
